import Breadcrumb from "../components/Breadcrumb";
import PlateAuthoritiesLayer from "../components/PlateAuthoritiesLayer";
import Profile from "../components/Profile";
import ProfileLayer from "../components/ProfileLayer";
import Roles from "../components/Roles";

const PlateAuthoritiesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Plate Authorities" />

      {/*All Clients Layer*/}
      <PlateAuthoritiesLayer />
    </>
  );
};

export default PlateAuthoritiesPage;
